import React from 'react';

import I18n from 'utils/I18n';
import Cldr from 'utils/Cldr';

import { useCheckoutContext } from '../../state/CheckoutContext';
import { getPromotionTag, subscriptionType } from '../../utils/checkoutUtils';
import { I18nPrefixTerms } from '../../shared/constants';

import styles from './Terms.scss';

export const Terms = () => {
  const { checkoutEntityState } = useCheckoutContext();

  const {
    duration,
    isTrial,
    currency,
    isStudentPromotion,
    isHolidayPromotion,
    products,
    pricing,
    promoCampaign
  } = checkoutEntityState;
  const hideTerms = products?.promotion?.full || isHolidayPromotion;
  if (hideTerms) {
    return null;
  }

  const { billedToday, priceWithoutDiscount, recurringAmount } = pricing;
  const promotionApplied = !!products?.promotion?.code || promoCampaign;
  const promotionDuration = products?.promotion?.argument;
  const promotionTag = getPromotionTag(isStudentPromotion, isHolidayPromotion);

  // ignoring students here since they have their own terms and can't redeem other promos
  const promotionCopyKey =
    promotionTag === 'none' ? 'percent_off' : 'extended_duration';

  const formatPrice = (price) => Cldr.formatCurrency(price, currency);

  let content;
  if (isStudentPromotion) {
    content = I18n.t(
      `${I18nPrefixTerms}.students.${subscriptionType(isTrial)}`,
      {
        studentPrice: formatPrice(recurringAmount),
        priceWithoutDiscount: Cldr.formatCurrency(
          priceWithoutDiscount,
          currency
        )
      }
    );
  } else if (promotionApplied) {
    content = I18n.t(
      `${I18nPrefixTerms}.promo.${promotionCopyKey}.${duration}`,
      {
        promoPrice: formatPrice(billedToday),
        promoDuration: promotionDuration,
        count: promotionDuration,
        price: formatPrice(recurringAmount)
      }
    );
  } else {
    content = I18n.t(
      `${I18nPrefixTerms}.${subscriptionType(isTrial)}.${duration}`,
      {
        price: formatPrice(recurringAmount)
      }
    );
  }

  return (
    <div className={styles.termsContainer}>
      <p className={styles.terms} data-testid="terms">
        {content}
      </p>
    </div>
  );
};

export default Terms;
